import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from 'src/store';
import {
  AXIOS_DELETE,
  AXIOS_GET,
  AXIOS_PATCH,
  AXIOS_POST,
  BASE_URL
} from './service/apiService';
import { snackbarGlobConfig } from 'src/globalConfig';

// State type
export interface exitApprovalState {
  exitEmployeeList: any[] | null;
  exitStagesEmployeeList: any[] | null;
  exitCheckList: any[] | null;
  exitDashboard: any[] | null;
  exitDashboardChecklist:any[]| null;
  saveExitApprovalStatus: {
    loading: boolean;
    success: boolean;
    error: string | null;
  };
}

const initialState: exitApprovalState = {
  exitEmployeeList: null,
  exitStagesEmployeeList: null,
  exitCheckList: null,
  exitDashboard: null,
  exitDashboardChecklist:null,
  saveExitApprovalStatus: {
    loading: false,
    success: false,
    error: null
  }
};

// Slice
const exitApprovalSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setExitEmployeeList(
      state,
      action: PayloadAction<{ exitEmployeeList: any[] }>
    ) {
      state.exitEmployeeList = action.payload.exitEmployeeList;
    },
    resetExitEmployeeList(state) {
      state.exitEmployeeList = null;
    },
    setExitCheckList(state, action: PayloadAction<{ ExitCheckList: any[] }>) {
      state.exitCheckList = action.payload.ExitCheckList;
    },
    resetExitCheckList(state) {
      state.exitCheckList = null;
    },

    saveExitApprovalStart(state) {
      state.saveExitApprovalStatus = {
        loading: true,
        success: false,
        error: null
      };
    },
    saveExitApprovalSuccess(state) {
      state.saveExitApprovalStatus = {
        loading: false,
        success: true,
        error: null
      };
    },
    saveExitApprovalFailure(state, action: PayloadAction<string>) {
      state.saveExitApprovalStatus = {
        loading: false,
        success: false,
        error: action.payload
      };
    },
    resetSaveExitApproval(state) {
      state.saveExitApprovalStatus = {
        loading: false,
        success: false,
        error: null
      };
    },
    setExitDashboard(state, action: PayloadAction<{ exitDashboard: any[] }>) {
      state.exitDashboard = action.payload.exitDashboard;
    },
    resetExitDashboard(state) {
      state.exitDashboard = null;
    },

    setExitDashboardEmployeeList(
      state,
      action: PayloadAction<{ exitStagesEmployeeList: any[] }>
    ) {
      state.exitStagesEmployeeList = action.payload.exitStagesEmployeeList;
    },
    resetExitDashboardEmployeeList(state) {
      state.exitStagesEmployeeList = null;
    },
 setDashboardChecklist(state, action: PayloadAction<any>) {
  console.log("action", action.payload);
  state.exitDashboardChecklist = action.payload; // now stores object, not array
}
,
    resetExitDashboardChecklist(state){
      state.exitDashboardChecklist=null
    }
  }
});

export const {
  setExitEmployeeList,
  resetExitEmployeeList,
  setExitCheckList,
  resetExitCheckList,
  saveExitApprovalStart,
  saveExitApprovalSuccess,
  saveExitApprovalFailure,
  resetSaveExitApproval,
  setExitDashboard,
  resetExitDashboard,
  setExitDashboardEmployeeList,
  resetExitDashboardEmployeeList,
  setDashboardChecklist,
  resetExitDashboardChecklist
} = exitApprovalSlice.actions;
export default exitApprovalSlice.reducer;
export const reducer = exitApprovalSlice.reducer;
//
// Thunk to fetch Exit Employee List
//
export const getExitEmployeeList = (
  projectId: number,
  startDate: string,
  endDate: string,
  snackBar: any
): AppThunk => async dispatch => {
  try {
    const response: any = await AXIOS_GET(
      `/api/user/exit-resources/list?startDate=${startDate ||
        ''}&endDate=${endDate || ''}&project=${projectId || ''}`,
      {},
      {}
    );
    if (response?.data) {
      dispatch(setExitEmployeeList({ exitEmployeeList: response?.data }));
      return { status: true, data: response?.data };
    } else {
      snackBar(response?.message, snackbarGlobConfig('error'));
      dispatch(resetExitEmployeeList());
      return { status: false, data: null };
    }
  } catch (err) {
    snackBar(err, snackbarGlobConfig('error'));
    dispatch(resetExitEmployeeList());
    return { status: false, data: null };
  }
};

export const getExitCheckList = (
  empId: string,
  projectId: number,
  snackBar: any
): AppThunk => async dispatch => {
  try {
    const response: any = await AXIOS_GET(
      `/api/exitStages/get-stages?page=1&limit=100&empId=${empId || ''}&project=${projectId || ''}`,
      {},
      {}
    );
    if (response?.data) {
      dispatch(setExitCheckList({ ExitCheckList: response?.data }));
      return { status: true, data: response?.data };
    } else {
      snackBar(response?.message, snackbarGlobConfig('error'));
      dispatch(resetExitCheckList());
      return { status: false, data: null };
    }
  } catch (err) {
    snackBar(err, snackbarGlobConfig('error'));
    dispatch(resetExitCheckList());
    return { status: false, data: null };
  }
};

//save exit approval

export const saveExitApproval = (
  payload: any,
  snackBar: any
): AppThunk => async dispatch => {
  try {
    dispatch(saveExitApprovalStart());

    const response: any = await AXIOS_POST(
      `/api/trans-stages/create`,
      payload,
      {}
    );

    if (response?.data) {
      dispatch(saveExitApprovalSuccess());
      snackBar(
        'Exit approval saved successfully',
        snackbarGlobConfig('success')
      );

      // optionally re-fetch exitCheckList here
      // dispatch(getExitCheckList(payload[0]?.employee, projectId, snackBar));

      return { status: true, data: response?.data };
    } else {
      dispatch(
        saveExitApprovalFailure(
          response?.message || 'Failed to save exit approval'
        )
      );
      snackBar(
        response?.message || 'Failed to save exit approval',
        snackbarGlobConfig('error')
      );
      return { status: false, data: null };
    }
  } catch (err) {
    dispatch(saveExitApprovalFailure(err?.message || 'Something went wrong'));
    snackBar(
      err?.message || 'Something went wrong',
      snackbarGlobConfig('error')
    );
    return { status: false, data: null };
  }
};

export const getExitDashboard = (
  startDate: string,
  endDate: string,
  snackBar: any
): AppThunk => async dispatch => {
  try {
    const response: any = await AXIOS_GET(
      `/api/exitStages/dashboard/exit?startDate=${startDate ||
        ''}&endDate=${endDate || ''}`,
      {},
      {}
    );
    if (response?.data) {
      dispatch(setExitDashboard({ exitDashboard: response?.data }));
      return { status: true, data: response?.data };
    } else {
      snackBar(response?.message, snackbarGlobConfig('error'));
      dispatch(resetExitDashboard());
      return { status: false, data: null };
    }
  } catch (err) {
    snackBar(err, snackbarGlobConfig('error'));
    dispatch(resetExitDashboard());
    return { status: false, data: null };
  }
};

export const getExitDashboardEmployeeList = (
  startDate: string,
  endDate: string,
  page: number,
  limit: number,
  projectFilter: string,
  statusFilter: string,
  sortBy: string,
  sortOrder: string,
  snackBar: any
): AppThunk => async dispatch => {
  try {
    const response: any = await AXIOS_GET(
      `/api/exitStages/dashboard/list?startDate=${startDate ||
        ''}&endDate=${endDate || ''}&page=${page || 0}&limit=${limit ||
        10}&projectId=${projectFilter ||
        ''}&statusFilter=${statusFilter}&sortBy=${sortBy ||
        ''}&sortOrder=${sortOrder || ''}`,
      {},
      {}
    );
    if (response?.data) {
      dispatch(
        setExitDashboardEmployeeList({ exitStagesEmployeeList: response?.data })
      );
      return { status: true, data: response?.data };
    } else {
      snackBar(response?.message, snackbarGlobConfig('error'));
      dispatch(resetExitDashboardEmployeeList());
      return { status: false, data: null };
    }
  } catch (err) {
    snackBar(err, snackbarGlobConfig('error'));
    dispatch(resetExitDashboard());
    return { status: false, data: null };
  }
};
